import { Link } from "react-router-dom"
import './List.css'

function List(props) {

    // list items this month, filters:
    let itemsToList = props.data

    // filter on month
    itemsToList = itemsToList.filter(item => item.date.includes(props.chosenMonth))

    // filter - remove europe
    if (!props.showEuropean) {
        itemsToList = itemsToList.filter(item => !item.europe_only)
    }

    // filter - remove vegetables
    if (!props.filterCategory.vegetable) {
        itemsToList = itemsToList.filter(item => item.category !== "vegetable")
    }

    // filter - remove root
    if (!props.filterCategory.root) {
        itemsToList = itemsToList.filter(item => item.category !== "root")
    }

    // filter - remove fruit
    if (!props.filterCategory.fruit) {
        itemsToList = itemsToList.filter(item => item.category !== "fruit")
    }

    // filter - remove berry
    if (!props.filterCategory.berry) {
        itemsToList = itemsToList.filter(item => item.category !== "berry")
    }

    // filter - remove mushroom
    if (!props.filterCategory.mushroom) {
        itemsToList = itemsToList.filter(item => item.category !== "mushroom")
    }

    // filter - remove berry
    if (!props.filterCategory.herb) {
        itemsToList = itemsToList.filter(item => item.category !== "herb")
    }
    
    // create list to show
    const list = itemsToList.map(item => {    
        if (item.img === "") item.img = "img/no-photo.jpg"
            return (
                <Link to={item.slug} key={item.slug}>
                    <li className="itemInList">
                        <div>
                            <img src={item.img} alt={item.name}/>
                        </div>
                        <div>
                            {item.name}
                            {item.europe_only ? 
                                <>&nbsp;<img src="/img/europeflag.png" alt="Europe" /></> : 
                                null
                            }
                        </div>
                    </li>
                </Link>
            )
    })

    // check if there is results
    const showList = () => {
        if (list.length <= 0) {
            return <p>Inga frukter eller grönsaker som matchar dina filter den här månaden.</p>
        } else {
            return (
                <ul className="list">
                    {list}
                </ul>
            )
        }
    }

    return (
        <>
            {showList()}
        </>
    )
}

export default List